export enum CardStyle {
  MAIN = 'MAIN',
  DISABLE = 'DISABLE',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  WAITING = 'WAITING',
}
